import React from "react";
import AppStyles from "../../styles/AppStyles.jsx";
import Head from "../../Head.jsx";
import { toElementProps } from "../../Element";

export function BlockProjectStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .block-project": {
            position: "relative",
            width: "100%",
            minHeight: "100%",

            [MobileBreakpoint]: {
                "& .desktop-240px-height": {
                    height: "unset",
                },
            },
        },
    };
}

export default function BlockProject(props) {
    // TODO: Great thing for the future
    /* React.useEffect(() => {
        if (!window.IntersectionObserver) {
            return null;
        }

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5,
        };

        let callback = (entries, observer) => {
            entries.forEach((entry) => {
                const { target } = entry;
                if (entry.isIntersecting) {
                    target.style.setProperty("opacity", "1");
                    target.style.setProperty("transform", `translateX(0)`);
                } else if (target.getAttribute("intersected") === null) {
                    target.setAttribute("intersected", "");
                    target.style.setProperty("opacity", "0");
                    target.style.setProperty(
                        "transform",
                        `translateX(${target.classList.contains("even") ? "-20vw" : "20vw"})`
                    );

                    setTimeout(() => {
                        target.style.setProperty("transition", "all 500ms ease-out");
                    }, 100);
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);

        document.querySelectorAll(".-intersect-").forEach((dom) => {
            observer.observe(dom);
        });
    }, []); */

    const elProps = toElementProps(props, { className: ["block-project"] });
    return (
        <div {...elProps}>
            <Head variables={props.variables} />
            {props.children && <AppStyles variables={props.variables}>{props.children}</AppStyles>}
        </div>
    );
}
